export const windowIsExist = typeof window !== "undefined";
